<script lang="ts">
	import { useSvelteFlow } from '@xyflow/svelte';
	import type { Writable } from 'svelte/store';

	/** Store to receive screenToFlowPosition from useSvelteFlow (must be inside SvelteFlow context) */
	export let screenToFlowPositionStore: Writable<
		((pos: { x: number; y: number }) => { x: number; y: number }) | null
	>;

	const api = useSvelteFlow();
	$: if (api && screenToFlowPositionStore) {
		screenToFlowPositionStore.set(api.screenToFlowPosition);
	}
</script>
